<script>
const LangListAPI = "https://ams4you.net/amsapi/public/websearch/GetLangLanguageList";
const LangChangeAPI = "https://ams4you.net/amsapi/public/websearch/GetLangLanguageChange";

import axios from "axios";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
export default {
    components: {
        Datepicker,
    },
    data() {
        return {
            query: "",
            SelLang: {},
            SelCountry: {},
            SelWeek: {
                Id: 4,
                Name: "4 weeks",
            },
            SelDate: "",
            LanguageList: [],
            CountryList: [],
        };
    },
    computed: {
        WeekList() {
            let list = [];
            for (let i = 1; i <= 52; i++) {
                list.push({
                    Id: i,
                    Name: i == 1 ? i + " week" : i + " weeks",
                });
            }
            return list;
        },
        Setting() {
            return this.$parent.Setting;
        },
        Translation() {
            return this.$parent.Translation;
        },
    },
    watch: {
        SelLang(val) {
            this.SelCountry = {
                Id: 0,
                Name: this.Translation.SelectCountry,
            };
            this.LanguageList.CountryList = [];
            if (val?.LanguageId) {
                let LatestQuery = this.query + "&LanguageId=" + val.LanguageId;
                this.GetCountries(LatestQuery);
            }
        },
    },
    methods: {
        MakeSearch() {
            let Path = this.Setting.Url + "/search/language";

            let query = "?CountryId=" + this.SelCountry.Id + "&LevelId=" + this.SelLang.LanguageId + "&Weeks=" + this.SelWeek.Id + "&StartDate=" + moment(this.SelDate).format("YYYY-MM-DD");
            window.open(Path + query, this.Setting.OpenInNewWindow ? "_blank" : "_self");
        },
        async GetLanguageList() {
            let ag = this.$parent.ag;
            let wid = this.$parent.wid;
            this.query = "?ag=" + ag + "&wfid=" + wid;
            const request = await axios.get(LangListAPI + this.query);
            const response = request.data;
            this.LanguageList = response.detail;
        },
        async GetCountries(Query) {
            const request = await axios.get(LangChangeAPI + Query);
            const response = request.data;
            this.CountryList = response.detail;
        },
    },
    mounted() {
        this.GetLanguageList();
        this.SelDate = new Date(moment().add(1, "month").toJSON());
    },
};
</script>
<template>
    <div class="widget">
        <div class="widget-content">
            <div class="form-row">
                <div class="form-row-icon" v-if="this.Setting.ShowIcons">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-translate" viewBox="0 0 16 16">
                        <path d="M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286H4.545zm1.634-.736L5.5 3.956h-.049l-.679 2.022H6.18z" />
                        <path
                            d="M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2zm7.138 9.995c.193.301.402.583.63.846-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6.066 6.066 0 0 1-.415-.492 1.988 1.988 0 0 1-.94.31z"
                        />
                    </svg>
                </div>
                <v-select
                    class="form-control"
                    placeholder="Test"
                    :options="LanguageList"
                    :getOptionLabel="(option) => option.LanguageName || Translation.SelectLanguage"
                    label="LanguageName"
                    :clearable="false"
                    v-model="SelLang"
                />
            </div>
            <div class="form-row">
                <div class="form-row-icon" v-if="this.Setting.ShowIcons">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-globe2" viewBox="0 0 16 16">
                        <path
                            d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855-.143.268-.276.56-.395.872.705.157 1.472.257 2.282.287V1.077zM4.249 3.539c.142-.384.304-.744.481-1.078a6.7 6.7 0 0 1 .597-.933A7.01 7.01 0 0 0 3.051 3.05c.362.184.763.349 1.198.49zM3.509 7.5c.036-1.07.188-2.087.436-3.008a9.124 9.124 0 0 1-1.565-.667A6.964 6.964 0 0 0 1.018 7.5h2.49zm1.4-2.741a12.344 12.344 0 0 0-.4 2.741H7.5V5.091c-.91-.03-1.783-.145-2.591-.332zM8.5 5.09V7.5h2.99a12.342 12.342 0 0 0-.399-2.741c-.808.187-1.681.301-2.591.332zM4.51 8.5c.035.987.176 1.914.399 2.741A13.612 13.612 0 0 1 7.5 10.91V8.5H4.51zm3.99 0v2.409c.91.03 1.783.145 2.591.332.223-.827.364-1.754.4-2.741H8.5zm-3.282 3.696c.12.312.252.604.395.872.552 1.035 1.218 1.65 1.887 1.855V11.91c-.81.03-1.577.13-2.282.287zm.11 2.276a6.696 6.696 0 0 1-.598-.933 8.853 8.853 0 0 1-.481-1.079 8.38 8.38 0 0 0-1.198.49 7.01 7.01 0 0 0 2.276 1.522zm-1.383-2.964A13.36 13.36 0 0 1 3.508 8.5h-2.49a6.963 6.963 0 0 0 1.362 3.675c.47-.258.995-.482 1.565-.667zm6.728 2.964a7.009 7.009 0 0 0 2.275-1.521 8.376 8.376 0 0 0-1.197-.49 8.853 8.853 0 0 1-.481 1.078 6.688 6.688 0 0 1-.597.933zM8.5 11.909v3.014c.67-.204 1.335-.82 1.887-1.855.143-.268.276-.56.395-.872A12.63 12.63 0 0 0 8.5 11.91zm3.555-.401c.57.185 1.095.409 1.565.667A6.963 6.963 0 0 0 14.982 8.5h-2.49a13.36 13.36 0 0 1-.437 3.008zM14.982 7.5a6.963 6.963 0 0 0-1.362-3.675c-.47.258-.995.482-1.565.667.248.92.4 1.938.437 3.008h2.49zM11.27 2.461c.177.334.339.694.482 1.078a8.368 8.368 0 0 0 1.196-.49 7.01 7.01 0 0 0-2.275-1.52c.218.283.418.597.597.932zm-.488 1.343a7.765 7.765 0 0 0-.395-.872C9.835 1.897 9.17 1.282 8.5 1.077V4.09c.81-.03 1.577-.13 2.282-.287z"
                        />
                    </svg>
                </div>
                <v-select
                    class="form-control"
                    :options="CountryList"
                    label="Name"
                    :getOptionLabel="(option) => option.Name || Translation.SelectCountry"
                    :clearable="false"
                    v-model="SelCountry"
                    :disabled="!SelLang?.LanguageId"
                />
            </div>
            <div class="form-row">
                <div class="form-row-icon" v-if="this.Setting.ShowIcons">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar2-week" viewBox="0 0 16 16">
                        <path
                            d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"
                        />
                        <path
                            d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4zM11 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"
                        />
                    </svg>
                </div>
                <v-select class="form-control" :options="WeekList" label="Name" :getOptionLabel="(option) => option.Name || ''" :clearable="false" v-model="SelWeek" :disabled="!SelCountry?.Id" />
            </div>
            <div class="form-row">
                <div class="form-row-icon" v-if="this.Setting.ShowIcons">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar4-event" viewBox="0 0 16 16">
                        <path
                            d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1H2zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5z"
                        />
                        <path d="M11 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z" />
                    </svg>
                </div>
                <datepicker
                    :disabled-dates="{
                        to: new Date(),
                    }"
                    v-model="SelDate"
                    :disabled="!SelWeek?.Id || !SelCountry?.Id"
                    class="form-control"
                    :editable="false"
                    placeholder="Select date"
                    :format="'dd-MM-yyyy'"
                ></datepicker>
            </div>
        </div>
        <div class="widget-footer">
            <button type="submit" class="btn fw-500 px-4 text-center flex-grow-1" :disabled="!SelLang?.LanguageId || !SelWeek?.Id || !SelCountry?.Id || !SelDate" @click="MakeSearch()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search me-1 fs-9" viewBox="0 0 16 16" v-if="this.Setting.ShowIcons">
                    <path
                        d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
                    />
                </svg>
                {{ Translation.Search }}
            </button>
        </div>
    </div>
</template>
